import React from 'react';
import InvoicesTable from './InvoicesTable';
import { ViewButton } from './components/ViewButton';
import { DownloadButton } from './components/DownloadButton';
import { DeleteButton } from './components/DeleteButton';
import { EditButton } from './components/EditButton';
import style from './InvoicesTable.styles.scss';

const InvoicesTableContainer = ({ invoices, setDeleteRow, ...restProps }) => {
  const getActions = (status, rowData) => {
    switch (status) {
      case 'ACCEPTED':
        return (
          <div className="d-flex">
            <ViewButton rowData={rowData} />
            <DownloadButton rowData={rowData} />
          </div>
        );
      case 'IN_DRAFT':
        return (
          <div className="d-flex">
            <DeleteButton rowData={rowData} setDeleteRow={setDeleteRow} />
            <EditButton rowData={rowData} />
          </div>
        );
      default:
        return <span>-</span>;
    }
  };

  const renderStatus = ({ status, t }) => {
    switch (status) {
      case 'ACCEPTED':
        return (
          <span className={style.accepted}>{t('invoice_list.SUBMITTED')}</span>
        );
      case 'IN_DRAFT':
        return <span>{t('invoice_list.IN_DRAFT')}</span>;
      case 'REJECTED':
        return (
          <span className={style.rejected}>
            {t('invoice_list.not_submitted')}
          </span>
        );
    }
  };

  return (
    <InvoicesTable
      getActions={getActions}
      invoices={invoices}
      renderStatus={renderStatus}
      {...restProps}
    />
  );
};

export default React.memo(InvoicesTableContainer);
